import React from "react";
import { useTranslation } from "react-i18next";

const PageNotFoundTemplate = () => {
  const { t } = useTranslation();
  return (
    <div className="flex h-screen w-screen flex-col items-center justify-center gap-5">
      <h2 className="heading-lg">{t("global:pageNotFound")}</h2>
      <p className="body-md px-5 text-center">
        {t("global:pageNotFound.description")}
      </p>
    </div>
  );
};

export default PageNotFoundTemplate;
